import { JS_CLEAR_ALT_MESSAGE } from '../actionTypes/GalleryActionTypes';
import { SET_IRIS_ALT_MESSAGE } from '../actionTypes/GalleryIrisActionTypes';

export default function altMessageReducer(state = '', action) {
    // NOSOANR
    switch (action.type) {
        case SET_IRIS_ALT_MESSAGE: {
            return action.payload;
        }
        case JS_CLEAR_ALT_MESSAGE:
            return '';

        default:
            return state;
    }
}

altMessageReducer.reducerName = 'altMessage';
